<div>
  <div class="modal-body mb-2 p-4">
    <div class="row">
      <div class="col d-flex justify-content-between">
        <p class="text-black font-weight-600 f-19 mb-1">Import Candidates to Talent Pool</p>
        <button data-testid="auto-app-csv-file-upload-model-button-1" type="button" class="close font-weight-normal ms-auto btn p-0 f-20 d-flex" (click)="dismiss('cancel')">
          <span aria-hidden="true">
            <i class="fal fa-times f-20 icon-color"></i>
          </span>
        </button>
      </div>
    </div>

    <div class="upload-csv-file-body" *ngIf="!validatedCSV">
      <div class="row mb-3">
        <div class="col">
          <p class="text-9696">
            Need help formatting your file?
            <span class="icon-color" style="cursor: pointer; color: #00425b;" (click)="downloadSampleCSV()">
              Download sample CSV
            </span>
          </p>
        </div>
      </div>

      <div class="wc-upload-btn2 mb-6 align-items-center" style="height: 100% !important;">
        <p class="f-18 my-3 text-black font-weight-600" *ngIf="!csvFile && !isInvalidCSV">
          Upload CSV file
        </p>
        <p class="f-18 my-3" *ngIf="csvFile">
          <i *ngIf="(csvFile && (isInvalidCSV || csvFileSizeError))"
            class="fa fa-exclamation-circle mr-1 font-weight-600 pointer text-danger"></i>
          <i *ngIf="(csvFile && !(isInvalidCSV || csvFileSizeError))"
            class="fas fa-check-circle text-green check-cirlcle mr-1 font-weight-600 text-blue-new"></i>
          {{ csvFile.name }}
        </p>

        <p class="f-14 icon-color my-3" *ngIf="!csvFile && !isInvalidCSV">
           Drag & drop your file here, or click to browse
        </p>
        <p class="f-14 my-3 text-danger" *ngIf="csvFile && isInvalidCSV">
          <span class="errormsg">File type should be <span class="font-weight-600">CSV</span> format</span>
        </p>
        <p class="f-14 my-3 text-danger" *ngIf="csvFile && csvFileSizeError">
          <span class="errormsg">Maximum file upload size: <span class="font-weight-600">10 MB</span></span>
        </p>

        <!-- <p class="f-14 text-9696 my-3" *ngIf="!csvFile && !isInvalidCSV">
          Only CSV format is supported with max size <span class="font-weight-600">10 MB</span>
        </p> -->
        <div style="text-align: left; margin-left: 65px;">
          <p class="f-14 text-9696 m-0" *ngIf="!csvFile && !isInvalidCSV">
            Supported format: <span class="font-weight-600">.CSV only</span>
          </p>
          <p class="f-14 text-9696 m-0" *ngIf="!csvFile && !isInvalidCSV">
            Maximum file size: <span class="font-weight-600">10 MB</span>
          </p>
          <p class="f-14 text-9696 m-0" *ngIf="!csvFile && !isInvalidCSV">
            Maximum records per upload: <span class="font-weight-600">500 candidates</span>
          </p>
        </div>
        <p class="f-14 icon-color font-weight-600 my-3" *ngIf="(csvFile && (isInvalidCSV || csvFileSizeError))">
          Retry
        </p>

        <input data-testid="auto-app-csv-file-upload-model-input-1" type="file" class="pb-2" name="file" (change)="uploadCSVFile($event)" accept=".csv" />
      </div>

      <div class="row">
        <div class="col">
          <div class="text-right">
            <button data-testid="auto-app-csv-file-upload-model-button-2" class="btn-trms-white mr-3" (click)="dismiss('cancel')">
              Cancel
            </button>
            <button data-testid="auto-app-csv-file-upload-model-button-3" class="btn-trms-medium" [ngClass]="{ 'bg-gray' : !(csvFile && !isInvalidCSV && !csvFileSizeError)}"
              [disabled]="!(csvFile && !isInvalidCSV && !csvFileSizeError)" (click)="submitLinkedinCSV()">
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="csv-processing-body" *ngIf="validatedCSV">
      <div class="wc-upload-btn2 mb-6 d-flex flex-column justify-content-center align-items-center"
        style="height: 100% !important;">
        <p class="text-9696 my-2 f-14" *ngIf="!isProcessingCSV">
          <i class="fa fa-exclamation-circle mr-1 font-weight-600 text-danger" *ngIf="linkedinCSVError?.length"></i>
          <i class="fas fa-check-circle text-green check-cirlcle f-18 ml-1 mr-1 font-weight-600"
            *ngIf="!linkedinCSVError?.length"></i>
          <span [class]="linkedinCSVError?.length ? 'text-danger' : ''">{{ linkedinCSVError || "Uploaded CSV processed
            successfully" }}</span>
        </p>
        <div class="progress-bar mb-2" style="width: 70% !important;">
          <mat-progress-bar color="icon-color" *ngIf="isProcessingCSV" mode="indeterminate"></mat-progress-bar>
          <mat-progress-bar color="icon-color" *ngIf="!isProcessingCSV" mode="determinate"
            value="100"></mat-progress-bar>
        </div>
        <p *ngIf="!isProcessingCSV" class="my-1">
          <i class="fa fa-exclamation-circle f-18 ml-1 mr-1 font-weight-600" style="color: #E58313;"></i>
          <span class="text-9696 f-14">{{ addBulkCandidateArray?.length || 0 }} out of {{
            linkedinCSVProcessingResponse?.data?.length }} were successfully uploaded</span>
        </p>
        <p class="text-9696 my-3 f-14" *ngIf="isProcessingCSV">Processing uploaded CSV in progress</p>
      </div>

      <div class="row mb-6" *ngIf="!isProcessingCSV && !linkedinCSVError.length">
        <div class="col">
          <p class="text-black font-weight-600 f-19 mb-2 ds-tooltip">
            File Status
            <i class="fal fa-info-circle f-12 text-9696 ml-1 pointer"></i>
            <!-- <span class="divTooltip">
              <p class="font-weight-500">Successful: {{ linkedinCSVProcessingResponse?.stats?.successful }} </p>
              <p class="font-weight-500">Unsuccessful: {{ linkedinCSVProcessingResponse?.stats?.unsuccessful }} </p>
              <p class="font-weight-500">Duplicate: {{ linkedinCSVProcessingResponse?.stats?.duplicate }} </p>
              <p class="font-weight-500">Partial: {{ linkedinCSVProcessingResponse?.stats?.partial }} </p>
            </span> -->
          </p>

          <div class="candidates-list-view mt-2 mb-2">
            <div class="pt-0" style="padding: 0 !important;">
              <section class="text-9696 f-14 font-weight-normal">
                <p *ngIf="!linkedinCSVProcessingResponse?.data || linkedinCSVProcessingResponse?.data?.length === 0"
                  class="my-2 text-center f-14">No candidates available</p>
                <div *ngIf="linkedinCSVProcessingResponse.data && linkedinCSVProcessingResponse.data?.length > 0">
                  <section
                    style="max-height: 300px !important; overflow-x: hidden !important; overflow-y: auto !important;"
                    class="mini-scroll">
                    <div class="row" *ngFor="let candidate of linkedinCSVProcessingResponse.data; let i=index">
                      <div class="col">
                        <hr *ngIf="i == 0" />
                        <div class="d-flex align-items-center">
                          <span class="status-icon mr-3">
                            <i class="fas fa-check-circle text-green check-cirlcle f-18 ml-1 font-weight-600 w-100"
                              *ngIf="candidate?.importstatus == 'successful'"></i>

                            <i class="fa fa-exclamation-circle f-18 ml-1 font-weight-600 w-100"
                              *ngIf="candidate?.importstatus == 'duplicate'" style="color: #E58313;"></i>

                            <i class="fa fa-exclamation-circle f-18 ml-1 font-weight-600 w-100 text-danger"
                              *ngIf="candidate?.importstatus == 'unsuccessful'"></i>
                          </span>
                          <span class="f-17 font-weight-500" style="text-transform: capitalize;">{{
                            candidate?.candidatebasicinfo?.firstname
                            }} {{ candidate?.candidatebasicinfo?.lastname }}</span>
                          <div class="ml-auto">
                            <span class="f-15 mr-1 font-weight-300" *ngIf="candidate?.importstatus == 'successful'">Successful</span>
                            <span class="f-15 mr-1 font-weight-300" *ngIf="candidate?.importstatus == 'duplicate'">Duplicate candidate
                              found</span>
                            <span class="f-15 mr-1 font-weight-300" *ngIf="candidate?.importstatus == 'unsuccessful'">Unsuccessful</span>
                          </div>
                        </div>
                        <hr />
                      </div>
                    </div>
                  </section>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="!isProcessingCSV">
        <div class="col">
          <!-- <div class="text-right">
            <button data-testid="auto-app-csv-file-upload-model-button-4" [disabled]="linkedinCSVError?.length"
              [class]="linkedinCSVError?.length ? 'btn-trms-white' : 'btn-trms-medium'" (click)="proceedWithCreatedCandidates()">
              Done
            </button>
          </div> -->

          <div class="d-flex justify-content-end align-items-center mt-2">
            <button data-testid="auto-app-csv-file-upload-model-button-5" class="btn-trms-white mr-3" (click)="dismiss()">Cancel</button>
            <button data-testid="auto-app-csv-file-upload-model-button-6" class="btn-trms-small ml-1"
              [ngClass]="{ 'bg-gray': bulkSpinnerLoader,  'text-center': bulkSpinnerLoader }"
              (click)="addBulkCandidate()" [disabled]="bulkSpinnerLoader">
              <span [ngClass]="{ 'spinner-border text-blue spinner-size': bulkSpinnerLoader }"
                [ngStyle]="{ 'width: 20px; height: 20px;': bulkSpinnerLoader }">
                {{bulkSpinnerLoader ? '' : 'Import Candidates'}}
              </span>
            </button>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
